export default __webpack_public_path__ + "static/media/a016-3.bf6a47f7.jpg";